import styled from 'styled-components';

export default styled.div`
	.motif-tooltip-wrapper .motif-tooltip-trigger-wrap .motif-icon-button.send-link-request {
		&:disabled {
			color: var(--ui-foreground-disabled) !important;
			.motif-icon svg { 
				color: var(--ui-foreground-disabled) !important;
			}
			path {
				fill: var(--ui-foreground-disabled) !important;
			}
		}
		width: unset;
		height: unset;
		display: flex;
	}
`;
